export const NEW_MESSAGE_LOG = "@iweb/NEW_MESSAGE_LOG"
